import { Link } from "react-router-dom";
import { Icon } from 'semantic-ui-react'

import { authProvider } from "../../auth";
import { useIsAdmin } from "../../hooks/isAdmin";
import { useHasMultipleOrganisations, useRunsClasses } from "../../hooks/organisations";
import { useCanAccessLeadership } from "../../hooks/canAccessLeadership";
import { useHasGalleries } from "../../hooks/galleries";
import { useHasPosts } from "../../hooks/posts";
import { PATHS } from "../../paths";

import styles from './Navigation.module.css';

function NavigationItem({ path, iconName, label }: { path: string, iconName: any, label: string }) {
  return (
    <Link to={path} className={styles.link}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Icon name={iconName} className={styles.icon} />
            <div>
                {label}
            </div>
        </div>
    </Link>
  );

}

function MobileNavigationFooter() {
  const isAdmin = useIsAdmin();
  const hasMultipleOrganisations = useHasMultipleOrganisations();
  const canAccessLeadership = useCanAccessLeadership();
  // Asks the data, not the organisation's type — see the note in `ResponsiveContainer`. Was
  // `!useIsSupportingOrganisation()`, which answers a different question that happens to agree.
  const runsClasses = useRunsClasses();
  const hasGalleries = useHasGalleries();
  const hasPosts = useHasPosts();

  if (!authProvider.isAuthenticated()) {
      return null;
  }

  // Leadership users get their own stripped-down nav — the Leadership page has its own top bar
  if (canAccessLeadership && !isAdmin) {
      return null;
  }

  return (
    <div className={styles.container}>
        {/* Classes and attendance records are meaningless in a supporter organisation — it has
            no courses — so they are hidden rather than leading to an empty page. */}
        {runsClasses && <NavigationItem path={PATHS.CLASSES} iconName='group' label='Classes' />}
        <NavigationItem path={PATHS.PEOPLE} iconName='user' label='People' />
        {runsClasses && <NavigationItem path={PATHS.ALL_RECORDS} iconName='folder open' label='Records' />}
        {canAccessLeadership && <NavigationItem path={PATHS.LEADERSHIP} iconName='bullhorn' label='Leadership' />}
        {/* Anyone holding a grant on a gallery in this organisation, not just content
            reviewers. Access to a gallery is a grant rather than a role — a centre manager or a
            teacher can hold one — so the only question that stays true is the server's own
            "what can you reach?". */}
        {hasGalleries && <NavigationItem path={PATHS.GALLERY} iconName='images' label='Gallery' />}
        {/* Hidden until they have written something: a bottom-bar slot is the scarcest space
            in the app, and an entry leading to an empty state does not earn one. */}
        {hasPosts && <NavigationItem path={PATHS.MY_POSTS} iconName='edit outline' label='My posts' />}
        {hasMultipleOrganisations && <NavigationItem path={PATHS.ORGANISATIONS} iconName='exchange' label='Switch' />}
        <NavigationItem path={PATHS.ADMIN_SETTINGS} iconName='cog' label='Settings' />
        <NavigationItem path={PATHS.LOGOUT} iconName='log out' label='Logout' />
    </div>
  );
}


export { MobileNavigationFooter };
